var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "icon_sort_svg__cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "icon_sort_svg__cls-3",
    d: "M21.6 30a1.08 1.08 0 001.18 1h17.56a1 1 0 100-1.93H22.78a1.08 1.08 0 00-1.18 1M14.39 5.18a1.09 1.09 0 001.18 1h24.77a1.09 1.09 0 001.18-1 1.09 1.09 0 00-1.18-1H15.57a1.09 1.09 0 00-1.18 1M14.39 13.44a1.09 1.09 0 001.18 1h24.77a1.09 1.09 0 001.18-1 1.09 1.09 0 00-1.18-1H15.57a1.09 1.09 0 00-1.18 1M14.39 21.7a1.09 1.09 0 001.18 1h24.77a1.09 1.09 0 001.18-1 1.09 1.09 0 00-1.18-1H15.57a1.09 1.09 0 00-1.18 1M14.39 38.21a1.1 1.1 0 001.18 1h24.77a1 1 0 100-1.93H15.57a1.09 1.09 0 00-1.18 1M12.08 28.89L9.17 31.7V5.18a1.15 1.15 0 10-2.3 0v26.5L4 28.89c-.46-.45-.66-.31-.45.3l4 11.35c.22.61.57.61.8 0l4.15-11.36c.23-.6 0-.74-.42-.29"
  }))));
}

export default SvgIconSort;